module.exports = __webpack_public_path__ + "img/11.fcf2beb3.webp";